<template>
    <div class="skeleton card"/>
</template>
<script>
export default {
    name: 'SkeletonCard',
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/colors';

.skeleton.card {
    margin-bottom: 16px;
    height: 64px;
}
</style>
